import { useState } from 'react'
import { Typography } from '@material-ui/core'
import { observer } from 'mobx-react-lite'
import { useMutation } from 'react-query'
import { useDMEStore } from '../../store'
import createCustomerPhysicianDetails from '../../requests/createCustomerPhysicianDetails'
import useStyles from './styles'
import PhysicianForm from '../../forms/PhysicianSearchForm/PhysicianForm'

export interface PhysicianDetailsFormProps {
  nextAction: () => void
}

export default observer(({ nextAction }: PhysicianDetailsFormProps) => {
  const store = useDMEStore()
  const classes = useStyles()
  const [isLoading, setIsLoading] = useState(false)

  const [createPhysicianDetailsMutation] = useMutation(
    createCustomerPhysicianDetails,
    {
      onSuccess: nextAction,
      onError: nextAction,
    }
  )

  const submitFunction = (data: any) => {
    const { firstName, lastName, stateName, city } = data
    const searchInputs = { firstName, lastName, city }
    setIsLoading(true)
    store.physician.setSearchInput({
      ...searchInputs,
      stateName,
    })
    createPhysicianDetailsMutation({
      firstName,
      lastName,
      addressState: stateName,
      addressCity: city,
    })
  }

  return (
    <>
      <Typography gutterBottom className={classes.disclaimer} variant="body1">
        Confirm your provider's information is correct and then continue to
        check out.
      </Typography>
      <PhysicianForm
        buttonText="Check Out"
        isLoading={isLoading}
        submitFunction={submitFunction}
      />
      <Typography
        className={classes.emailNotice}
        color="textSecondary"
        component="p"
        variant="caption"
      >
        We will email you if we need more information.
      </Typography>
    </>
  )
})
